<template>
  <div class="navbar">
    <el-col :span="8">
      <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar"/>
    </el-col>
    <el-col :span="16">
      <div class="right-menu">
        <el-dropdown class="avatar-container" trigger="click" style="cursor: pointer;">
        <span class="el-dropdown-link">
          <span>{{ this.$t('navbar.welcome') }} <span class="name">{{ this.profile.name }}</span></span>
          <i class="el-icon-caret-bottom"/>
        </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided @click.native="showChangePasswordModal"><i class="el-icon-user"/>
              {{ this.$t('navbar.change_password') }}
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout"><i class="el-icon-right"/> {{ this.$t('navbar.logout') }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-col>
    <change-password-modal ref="changePasswordModal"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
import ChangePasswordModal from '@/views/user/components/ChangePasswordModal'

export default {
  components: {
    ChangePasswordModal,
    Hamburger
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'sidebar',
      profile: 'auth/profile'
    })
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout () {
      const logoutResponse = await this.$store.dispatch('auth/logoutAction')
      if (logoutResponse.status === 200) {
        location.reload()
      }
    },
    showChangePasswordModal () {
      this.$refs.changePasswordModal.show()
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
  .breadcrumb-container {
    float: left;
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: $peasy-green;
      vertical-align: text-bottom;
      &.hover-effect {
        cursor: pointer;
        transition: background .3s;
        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
    .avatar-container {
      margin-right: 30px;
      line-height: 18px !important;
      .name {
        margin: 0 .5rem;
        cursor: pointer;
        color: $peasy_green;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/components/Navbar.vue